import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useUnselectAllExitIntent = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(() => dispatch({ type: 'CLEAR_CAMPAIGN_EXIT_INTENT' }), [dispatch]);
};
